import React, { useEffect, useState }  from 'react';
import NotFoundComp from '../components/notFoundComp';

function NotFound() {    
    return (
        <NotFoundComp />
      );    
       
}

export default NotFound;
